import { ColumnDef } from '@tanstack/react-table';

import { TLowStockItem } from '@/features/slice/inventory';

export const stockOutListColumns: Array<ColumnDef<TLowStockItem>> = [
    {
        accessorKey: 'product_name',
        header: () => <div>Product Name</div>,
        cell: ({ row }) => <div>{row.original.product_name}</div>,
    },

    {
        accessorKey: 'brand_name',
        header: () => <div>Brand Name</div>,
        cell: ({ row }) => <div>{row.original.brand_name}</div>,
    },

    {
        accessorKey: 'current_stock',
        header: () => <div className={'text-right'}>Current Stock</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.current_stock}</div>
        ),
    },

    {
        accessorKey: 'alert_quantity',
        header: () => <div className={'text-right'}>Alert Quantity</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.alert_quantity}</div>
        ),
    },
];
